import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public loading$ = this._loading.asObservable();
  
  private _isInitialLoad = true;
  private _initialLoadRequests = 0;
  private _initialLoadComplete = false;

  showLoader() {
    this._loading.next(true);
  }

  hideLoader() {
    this._loading.next(false);
  }

  // Mark that we're in initial load phase (called on app start)
  startInitialLoad() {
    this._isInitialLoad = true;
    this._initialLoadRequests = 0;
    this._initialLoadComplete = false;
    this.showLoader();
  }

  // Track an initial API request
  incrementInitialRequest() {
    if (this._isInitialLoad && !this._initialLoadComplete) {
      this._initialLoadRequests++;
    }
  }

  // Decrement when an initial API request completes
  decrementInitialRequest() {
    if (this._isInitialLoad && !this._initialLoadComplete) {
      this._initialLoadRequests--;
      if (this._initialLoadRequests <= 0) {
        this._initialLoadComplete = true;
        this._isInitialLoad = false;
        // Add small delay to ensure all initial requests are processed
        setTimeout(() => {
          if (this._initialLoadRequests <= 0) {
            this.hideLoader();
          }
        }, 200);
      }
    }
  }

  // Check if we're still in initial load phase
  isInitialLoadPhase(): boolean {
    return this._isInitialLoad && !this._initialLoadComplete;
  }

  // Force complete initial load (called when app is ready)
  completeInitialLoad() {
    if (this._isInitialLoad) {
      this._initialLoadComplete = true;
      this._isInitialLoad = false;
      setTimeout(() => {
        this.hideLoader();
      }, 200);
    }
  }
}
